import { Link } from 'react-router'
import BlurFade from '#app/components/magicui/blur-fade.tsx'
import { Icons } from '#app/components/icons.tsx'
import { buttonVariants } from '#app/components/ui/button.tsx'
import { DATA } from '#app/data/portfolio.tsx'
import { cn } from '#app/utils/misc.tsx'

const BLUR_FADE_DELAY = 0.04

const socials = Object.values(DATA.contact.social)

const Contact = () => {
	return (
		<section id="contact" className="container">
			<div className="grid w-full items-center justify-center gap-4 px-4 py-12 text-center md:px-6">
				<BlurFade delay={BLUR_FADE_DELAY * 11}>
					<div className="space-y-3">
						<div className="bg-foreground text-background inline-block rounded-lg px-3 py-1 text-sm">
							Follow Along
						</div>
						<h2 className="text-3xl font-bold tracking-tighter sm:text-5xl">
							Building in Public
						</h2>
						<p className="text-muted-foreground mx-auto max-w-[600px] md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed">
							I write about building crypto and financial-data tools — and what
							I learn using AI to ship faster.
						</p>
						<div className="flex flex-wrap justify-center gap-3 pt-4">
							<Link
								to={DATA.contact.social.X.url}
								target="_blank"
								className="bg-foreground text-background hover:bg-foreground/90 inline-flex items-center gap-2 rounded-lg px-6 py-3 font-medium transition-colors"
							>
								<Icons.x className="size-4" />
								Follow @underemployed on X
							</Link>
							<Link
								to="/resume"
								className="hover:bg-muted/50 inline-flex items-center gap-2 rounded-lg border px-6 py-3 font-medium transition-colors"
							>
								View résumé
							</Link>
						</div>
						<div className="flex justify-center gap-2 pt-2">
							{socials.map((social) => (
								<Link
									key={social.name}
									to={social.url}
									target={
										social.url.startsWith('mailto:') ? undefined : '_blank'
									}
									rel="noreferrer"
									aria-label={social.name}
									className={cn(
										buttonVariants({ variant: 'outline', size: 'icon' }),
										'rounded-full',
									)}
								>
									<social.icon className="size-4" />
								</Link>
							))}
						</div>
					</div>
				</BlurFade>
			</div>
		</section>
	)
}

export default Contact
